module.exports = __webpack_public_path__ + "img/step3.23f07fea.png";